import { render, staticRenderFns } from "./ViewChallenge.vue?vue&type=template&id=72ae62c3&scoped=true&"
import script from "./ViewChallenge.vue?vue&type=script&lang=js&"
export * from "./ViewChallenge.vue?vue&type=script&lang=js&"
import style0 from "./ViewChallenge.vue?vue&type=style&index=0&id=72ae62c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ae62c3",
  null
  
)

export default component.exports